export default __webpack_public_path__ + "static/media/name-profile-inactive.d6321ba3.svg";